import { checkboxDefaultInitialState } from "../../../../../components/Filter/checkbox";
import { PreOrderStatusOptionList } from "../../../../../constants/PreOrderStatus";

export const preOrderFieldNames = {
  CREATE_DATE: "createdAt",
  AUTHOR: "authorList",
  STATUS: "statusList",
  SEARCH: "search",
};

export const preOrderStatusOptionList = PreOrderStatusOptionList;

export const preOrderFiltersInitialState = {
  [preOrderFieldNames.CREATE_DATE]: {
    from: null,
    to: null,
  },
  [preOrderFieldNames.AUTHOR]: {},
  [preOrderFieldNames.STATUS]: checkboxDefaultInitialState(PreOrderStatusOptionList),
};
